import { render, staticRenderFns } from "./UserGroupBinPermissions.vue?vue&type=template&id=db445240&scoped=true"
import script from "./UserGroupBinPermissions.vue?vue&type=script&lang=js"
export * from "./UserGroupBinPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserGroupBinPermissions.vue?vue&type=style&index=0&id=db445240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db445240",
  null
  
)

export default component.exports